// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"01ae5ec802f25adb4e4a","655":"26b767cb34bd4a0bcba7"}[chunkId] + ".js";
};